

import React from "react";

const sectionStyle: React.CSSProperties = {
  background: "white",
  borderRadius: 18,
  padding: "20px 22px",
  border: "1px solid #d8e1eb",
  boxShadow: "0 8px 24px rgba(23,59,87,0.06)",
  lineHeight: 1.8,
};

const Terms: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #eef4fb 0%, #f8fbff 100%)",
        padding: "32px 16px 48px",
        boxSizing: "border-box",
      }}
    >
      <div style={{ maxWidth: 960, margin: "0 auto" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #0c2031 0%, #173b57 54%, #2a6b98 100%)",
            color: "white",
            borderRadius: 24,
            padding: "28px 24px",
            boxShadow: "0 18px 40px rgba(12,32,49,0.18)",
            marginBottom: 20,
          }}
        >
          <div style={{ fontSize: 13, opacity: 0.85, letterSpacing: "0.08em", marginBottom: 8 }}>
            dachouの謎解き問題集
          </div>
          <h1 style={{ margin: 0, fontSize: 32, lineHeight: 1.2 }}>利用規約</h1>
          <div style={{ marginTop: 10, fontSize: 14, opacity: 0.85, lineHeight: 1.7 }}>
            本規約は、当サイトの利用条件を定めるものです。利用者は本規約に同意した上でサービスをご利用ください。
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>第1条（適用）</h2>
            <p>
              本規約は、当サイトの提供するサービスの利用条件を定めるものであり、利用者と運営者との間の一切の関係に適用されます。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>第2条（禁止事項）</h2>
            <ul>
              <li>法令または公序良俗に違反する行為</li>
              <li>当サイトの運営を妨害する行為</li>
              <li>不正アクセスやそれを試みる行為</li>
              <li>他のユーザーに迷惑をかける行為</li>
              <li>コンテンツの無断転載・再配布</li>
            </ul>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>第3条（サービス内容）</h2>
            <p>
              当サイトは、無料で遊べる謎解き問題を提供します。内容は予告なく変更・追加・削除される場合があります。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>第4条（免責事項）</h2>
            <p>
              当サイトの利用によって生じた損害について、運営者は一切の責任を負いません。また、コンテンツの正確性や安全性について保証するものではありません。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>第5条（著作権）</h2>
            <p>
              当サイトに掲載されているコンテンツの著作権は運営者に帰属します。無断での転載・複製・配布を禁止します。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>第6条（規約の変更）</h2>
            <p>
              本規約は、必要に応じて予告なく変更される場合があります。
            </p>
          </section>
        </div>

        <div
          style={{
            marginTop: 18,
            textAlign: "right",
            color: "#667085",
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          最終更新日：2026年4月2日
        </div>
      </div>
    </div>
  );
};

export default Terms;